import { Swiper, Autoplay } from 'swiper';

Swiper.use( [ Autoplay ] );

const addonImagesElements = document.querySelectorAll( '.wp-block-qala-blocks-logo-slider' );

addonImagesElements.forEach( sliderInstance => {
	const imageSlider = sliderInstance.querySelector( '.logo-slider' );

	const oldSlider = imageSlider.classList.contains( 'old' );

	if ( oldSlider ) {
		imageSlider.querySelector( '.wp-block-gallery' ).classList.add( 'swiper-wrapper' );

		imageSlider.querySelectorAll( '.wp-block-image' ).forEach( image => {
			image.classList.add( 'swiper-slide' );
		} );
	}

	let sliderConfig = {
		slidesPerView: 'auto',
		loop: true,
	};

	// If we have autoplay on we want to tweak the config.
	if ( imageSlider.classList.contains( 'has-auto-carousel' ) ) {
		sliderConfig = {
			...sliderConfig,
			loop: true,
			centeredSlides: true,
			watchSlidesProgress: true,
			autoplay: {
				delay: 1,
				pauseOnMouseEnter: false,
				disableOnInteraction: false,
			},
			speed: 4000,
			allowTouchMove: false,
		};
	}

	// If we have autoplay on we want to tweak the config.
	if ( imageSlider.classList.contains( 'has-reverse-direction' ) ) {
		sliderConfig = {
			...sliderConfig,
			autoplay: {
				delay: 1,
				pauseOnMouseEnter: false,
				disableOnInteraction: false,
				reverseDirection: true,
			},
		};
	}

	new Swiper( imageSlider, sliderConfig );
} );
